export default "__VITE_ASSET__CugLAdeX__"